import { render, staticRenderFns } from "./DeviceIcon.vue?vue&type=template&id=136ba7ba&scoped=true&"
import script from "./DeviceIcon.vue?vue&type=script&lang=js&"
export * from "./DeviceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ba7ba",
  null
  
)

export default component.exports